import { AspectRatio, Box, Button, Modal, Stack, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { theme } from "../../../../components/Theme";
import { useTranslation } from "react-i18next";

type Props = {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmUpgradeModal = ({ show, onClose, onConfirm }: Props) => {
  const { t } = useTranslation();

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "#fff",
    boxShadow: 24,
    width: { xs: "94%", lg: "640px" },
    height: { xs: "90%", lg: "604px" },
    borderRadius: "32px",
    borderColor: "transparent",
    outline: "none",
    p: "40px",
  };

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  return (
    <Modal
      id="confirmchanges-modal"
      open={showModal}
      style={{
        backgroundColor: "#32383E99",
        backdropFilter: "unset",
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack
          direction={"column"}
          sx={{
            gap: "24px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            textAlign={"center"}
            level="text-xl-bold"
            id="modal-modal-title"
            textColor={theme.palette.common.black}
          >
            {t("upgradeAccount.form.confirm.title")}
          </Typography>

          <AspectRatio
            variant="plain"
            ratio={1}
            sx={{
              width: { xs: "200px", md: "300px" },
              height: { xs: "200px", md: "300px" },
            }}
          >
            <img src="/confirm-upgrade.png" />
          </AspectRatio>

          <Stack direction={"column"}>
            <Typography
              textAlign={"center"}
              level="text-md-regular"
              id="modal-modal-subtitle"
              textColor={theme.palette.text.secondary}
            >
              {t("upgradeAccount.form.confirm.prompt1")}
            </Typography>

            <Typography
              textAlign={"center"}
              level="text-md-bold"
              id="modal-modal-subtitle"
              textColor={theme.palette.text.secondary}
            >
              {t("upgradeAccount.form.confirm.prompt2")}
            </Typography>

            <Typography
              textAlign={"center"}
              level="text-md-regular"
              id="modal-modal-subtitle"
              textColor={theme.palette.text.secondary}
            >
              {t("upgradeAccount.form.confirm.prompt3")}
            </Typography>
          </Stack>

          <Stack
            direction={{ xs: "column-reverse", lg: "row" }}
            gap={{ xs: "8px", lg: "24px" }}
            width={"100%"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Button
              variant="linkz-outlined-primary"
              size="sm"
              onClick={onClose}
              sx={{ width: { xs: "100%", md: "50%" } }}
            >
              {t("commons.cancelBtn")}
            </Button>

            <Button
              size="sm"
              onClick={onConfirm}
              sx={{ width: { xs: "100%", md: "50%" } }}
            >
              {t("commons.confirmBtn")}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmUpgradeModal;
